@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/apex-chart.scss';

:host {
  background-color: var(--white-layout-302-level-1-elevation);
  padding-top: calc(var(--spacer) * 1.5);
  padding-bottom: calc(var(--spacer) * 1.5);
}

.wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  &.is-loading {
    .remediation-chart {
      opacity: 0;
    }
  }
}

.content {
  width: 100%;
  height: 200px;
}

.widget-loading {
  bottom: calc(var(--spacer) * 1.5);
}

// See https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript
#textWidthMeasurer {
  position: absolute;
  visibility: hidden;
  height: auto;
  width: auto;
  white-space: nowrap;
  font-size: var(--body-size);
}

.apexcharts-tooltip {
  left: var(--tooltip-left-position) !important;
  transition: none;

  &.apexcharts-active {
    transition: none;
  }
}

.remediation-chart {
  margin-left: -25px;

  .apexcharts-inner {
    transform: translateY(25px) translateX(30px);
  }

  .apexcharts-legend-series {
    display: flex !important;
    overflow-y: hidden;
    align-items: center;
  }

  .apexcharts-legend {
    .apexcharts-legend-text {
      font-size: var(--body-size-large) !important;
      color: var(--main-titles-inputs-600) !important;
      line-height: 24px;
      font-family: var(--font-family-secondary) !important;
    }
  }

  .apexcharts-tooltip {
    background-color: var(--white-layout-303-level-2-elevation);
    border: 10px;

    .tooltip {
      background-color: var(--white-layout-303-level-2-elevation);
      color: var(--main-titles-inputs-600);
      padding: calc(3 * var(--spacer));
      font-size: var(--body-size);
      white-space: normal;
      display: flex;
      align-items: center;

      &--bullet {
        width: 10px;
        height: 10px;
        display: inline-block;
        margin-right: var(--spacer);
      }

      &--value {
        font-weight: bold;
        margin-left: 3px;
      }
    }
  }

  .apexcharts-gridlines-vertical {
    line {
      stroke: var(--chart-101-pressed-dividers);
    }
  }

  .apexcharts-grid-borders {
    line {
      stroke: var(--chart-101-pressed-dividers);
    }
    line:nth-child(2) {
      transform: translateX(-3px);
    }
  }
}

.apexcharts-legend-series {
  margin-right: calc(var(--spacer) * 4) !important;

  &:last-of-type {
    margin-right: 0 !important;
  }

  .apexcharts-legend-marker {
    margin-right: var(--spacer);
    cursor: auto;
  }
}

.apexcharts-gridlines-horizontal {
  .apexcharts-gridline {
    &:first-of-type {
      display: none !important;
    }
  }
}

.apexcharts-gridlines-vertical {
  .apexcharts-gridline {
    &:last-of-type {
      transform: translateX(-3px);
    }
  }
}

.apexcharts-text tspan {
  font-family: var(--font-family-secondary-mono);
  fill: var(--main-titles-inputs-600);
}

.is-error,
.is-empty {
  .apexcharts-legend-series {
    pointer-events: none;
  }
}

:not(.is-error):not(.is-empty):not(.is-loading) {
  .apexcharts-legend-series {
    &.has-action {
      cursor: pointer;

      .apexcharts-legend-marker {
        cursor: pointer !important;
      }

      &:hover {
        .apexcharts-legend-text {
          color: var(--blue-layout-300-active) !important;
        }
      }

      &:focus {
        .apexcharts-legend-text {
          color: var(--blue-layout-500-focus) !important;
        }
      }

      &:active {
        .apexcharts-legend-text {
          color: var(--blue-layout-300-active) !important;
        }
      }
    }
  }
}

:host([data-display-mode='pdf']) {
  .wrapper {
    .content {
      .remediation-chart {
        .apexcharts-canvas {
          .apexcharts-grid {
            .apexcharts-gridlines-vertical + line,
            .apexcharts-gridlines-vertical + line + line {
              display: none;
            }
          }
          .apexcharts-xaxis {
            .apexcharts-xaxis-texts-g + line {
              display: none;
            }
          }
        }
        .apexcharts-legend-text {
          font-size: calc(var(--body-size) - 2px);
        }
      }
    }
  }
  .remediation-chart .apexcharts-inner {
    transform: translateY(25px) translateX(35px);
  }
}
